import { render, staticRenderFns } from "./estudantesListagem.vue?vue&type=template&id=46b1ca8a&scoped=true&"
import script from "./estudantesListagem.vue?vue&type=script&lang=js&"
export * from "./estudantesListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1ca8a",
  null
  
)

export default component.exports